module.exports = __webpack_public_path__ + "2be49397338904cc4e451f3f9f987292.svg";